import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ProjectDto } from '../application/dto/ProjectDto';
import { ProjectCard } from './ProjectCard';
import { IndustrialProjects } from './IndustrialProjects';
import { industrialProjectsContent } from '../content/industrial-projects.content';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './ProjectsPage.css';

export function ProjectsPage() {
  const projects = useLoaderData() as ProjectDto[];
  useDocumentHead(staticSeo.projectsList);

  return (
    <Container>
      <section className="dma-projects-page">
        <h1>پروژه‌ها و معادن</h1>
        <div className="dma-projects-page__grid">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </section>

      <IndustrialProjects projects={industrialProjectsContent} />
    </Container>
  );
}
